const axios = require('axios');
const { v4 } = require('uuid');

const apiPost = (apiUrl, route, data, token) =>
  axios.post(`${apiUrl}${route}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      correlationId: v4(),
    },
  });

const apiPut = (apiUrl, route, data, token) =>
  axios.put(`${apiUrl}${route}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      correlationId: v4(),
    },
  });

const apiPatch = (apiUrl, route, data, token) =>
  axios.patch(`${apiUrl}${route}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      correlationId: v4(),
    },
  });

const apiGet = (apiUrl, route, data, token, axiosOptions = {}) =>
  axios.get(`${apiUrl}${route}`, {
    params: { ...data },
    headers: {
      Authorization: `Bearer ${token}`,
      correlationId: v4(),
    },
    ...axiosOptions,
  });

const apiDelete = (apiUrl, route, data, token) =>
  axios.delete(`${apiUrl}${route}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      correlationId: v4(),
    },
    data,
  });

module.exports = {
  apiPost,
  apiPut,
  apiPatch,
  apiGet,
  apiDelete,
};
